import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId

const environment = 'snitch'

export default {
  namespaced: true,
  state: {
    serviceUnavailable: false,
    serviceRequested: false,
    fetchingProviders: false,
    gettingProvider: false,
    currentPage: 1,
    providersResultInfo: {},
    resultInfo: {},
    providers: [],
    provider: {},
    addingProvider: false,
    updatingProvider: false,
    removingProvider: false,
  },
  getters: {
    currentPage: state => state.currentPage,
  },
  mutations: {
    SET_SERVICE_UNAVAILABLE(state, value) {
      state.serviceUnavailable = true
      state.serviceRequested = value
    },
    SET_FETCHING_PROVIDERS(state, value) {
      state.fetchingProviders = value
    },
    SET_PROVIDERS(state, value) {
      state.providers = value.result
      state.providersResultInfo = value.resultInfo
    },
    GET_PROVIDER(state, value) {
      state.provider = value
    },
    SET_ADDING_PROVIDER(state, value) {
      state.addingProvider = value
    },
    SET_GETTING_PROVIDER(state, value) {
      state.gettingProvider = value
    },
    SET_CURRENT_PAGE(state, value) {
      state.currentPage = value
    },
    REMOVE_PROVIDER(state, id) {
      state.providers = state.providers.filter(h => h.id !== id)
    },
    SET_UPDATING_PROVIDER(state, value) {
      state.updatingProvider = value
    },
    SET_REMOVING_PROVIDER(state, value) {
      state.removingProvider = value
    },
  },
  actions: {
    fetchProviders({ commit }, query) {
      commit('SET_FETCHING_PROVIDERS', true)
      return new Promise((resolve, reject) => {
        api(environment).get(`projects/${getProjectId()}/providers?PageIndex=${query.pageIndex}&PageSize=${query.pageSize}`)
          .then(response => {
            commit('SET_PROVIDERS', response.data)
            resolve(response)
          })
          .catch(error => {
            if (error.response?.status === 426 || error.response?.status === 428) {
              commit('SET_SERVICE_UNAVAILABLE', error.response?.status === 428)
            }
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_PROVIDERS', false) })
      })
    },
    getProvider({ commit }, providerId) {
      commit('SET_GETTING_PROVIDER', true)
      return new Promise((resolve, reject) => {
        api(environment).get(`projects/${getProjectId()}/providers/${providerId}`)
          .then(response => {
            commit('GET_PROVIDER', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_PROVIDER', false) })
      })
    },
    addProvider({ commit }, query) {
      commit('SET_ADDING_PROVIDER', true)
      return new Promise((resolve, reject) => {
        api(environment).post(`/projects/${getProjectId()}/providers/`, query.provider)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_ADDING_PROVIDER', false) })
      })
    },
    updateProvider({ commit }, query) {
      commit('SET_UPDATING_PROVIDER', true)
      return new Promise((resolve, reject) => {
        api(environment).put(`/projects/${getProjectId()}/providers/${query.id}`, query.provider)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_UPDATING_PROVIDER', false) })
      })
    },
    removeProvider({ commit }, providerId) {
      commit('SET_REMOVING_PROVIDER', true)
      return new Promise((resolve, reject) => {
        api(environment).delete(`/projects/${getProjectId()}/providers/${providerId}`)
          .then(response => {
            commit('REMOVE_PROVIDER', providerId)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_REMOVING_PROVIDER', false) })
      })
    },
  },
}
